import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Hero.css';

const Hero = () => {
  const videoRef = useRef(null);
  
  useEffect(() => {
    // Ensure video plays automatically when component mounts
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.error("Video autoplay failed:", error);
      });
    }
  }, []);

  return (
    <section className="hero-section">
      {/* Background Video */}
      <div className="hero-video-wrapper">
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          className="hero-background-video"
        >
          <source src="/videos/video.mp4" type="video/mp4" />
          {/* Fallback for browsers that don't support video */}
          <div 
            className="hero-fallback" 
            style={{ 
              backgroundImage: 'url(/images/solar-panels.jpg)',
              backgroundPosition: '50% 50%'
            }}
          ></div>
        </video>
        <div className="hero-video-overlay"></div>
      </div>
      
      {/* Content */}
      <div className="hero-main-content">
        <div className="hero-inner-wrapper">
          <h1 className="hero-main-title">
            Cung cấp giải pháp công nghệ toàn diện cho doanh nghiệp của bạn
          </h1>
          
          <Link 
            to="/projects" 
            className="hero-projects-btn"
          >
            PROJECTS →
          </Link>
        </div>
        
        {/* Down Arrow */}
        <div className="hero-arrow-container">
            <img 
              src="/images/BT-D.png" 
              alt="Scroll down" 
              width={60} 
              height={120}
            className="hero-arrow-image"
            />
        </div>
      </div>
    </section>
  );
};

export default Hero;